import React, { Fragment, useContext, useRef } from 'react';
import { connect } from 'react-redux';
import clsx from 'clsx';
import ApplyAndAddEmpCard from '../../ApplyAndAddEmpCard';
import TcLinks from '../../TcLinks';
import { getAddAnEmployeeDtmEvents } from '../../../redux';
import { Image } from 'acq-components/lib/base-components/Image/Image';
import { Breakpoint, Typography } from '@americanexpress/aqx-components';
import ColorPicker, { parent } from 'src/universal/components/ColorPicker/index.js';
import { Sanitizer } from 'acq-components/lib/base-components/Sanitizer/Sanitizer';
import { HeroBanner } from 'acq-components/lib/composite-components/HeroBanner/HeroBanner';
import { LazyLoad } from 'acq-components/lib/services/performance/LazyLoad/LazyLoad';
import LazyScrollMetricTracker from 'src/universal/components/DTM/LazyScrollMetricTracker';
import { getSelectedColorInfo } from 'src/universal/redux/cardColors';
import { decideCardArtUrl } from 'src/universal/utils/cardColorChoices';
import {
  DynamicAppModalContext,
  ModalButtonRefContext
} from 'src/universal/components/DynamicApp/redux';
import styles from '../__styles__/index.scss?modules';
import applyButtonStyles from '../__styles__/RIBApply.scss?modules';
import TcLinksStyles from '../__styles__/TcLinksStyles.scss?modules';
import { sendDTMClickEvent } from 'service_modules/models/dtm-tagging';

const ReinforcementBanner = React.memo(
  ({
    bannerData = {},
    addAnEmployeeScrollDtm,
    hasUpgradeCta,
    colorInfo,
    dynAppStyling = false
  }) => {
    const { title, cardArt, cardTitle, dtm: scrollDtm, learnMoreLink } = bannerData;
    let { subTitle } = bannerData;
    const cardArtUrl = decideCardArtUrl(cardArt, colorInfo);
    const { reinforcementBanner } = addAnEmployeeScrollDtm;
    const tncProps = {
      styles: TcLinksStyles
    };
    if (hasUpgradeCta) {
      tncProps.customKeys = ['offerTermsUpgrade', 'ratesFeesUpgrade'];
    }
    const designList = colorInfo?.designVariations?.cardDesigns || [];
    const hasColorPicker = designList.length > 1;
    const setIsDynamicModalOpen = useContext(DynamicAppModalContext);
    const thisButtonRef = useRef(null);
    const { setButtonRef } = useContext(ModalButtonRefContext);
    let learnMoreButton;
    if (dynAppStyling) {
      learnMoreButton = (
        <button
          className={styles.learnMoreButton}
          ref={thisButtonRef}
          onClick={() => {
            setButtonRef(thisButtonRef);
            setIsDynamicModalOpen();
            sendDTMClickEvent(learnMoreLink?.dtm);
          }}
        >
          {learnMoreLink?.text}
        </button>
      );
    }
    return (
      <React.Fragment>
        <LazyScrollMetricTracker
          scrollDtm={scrollDtm}
          startTrackingAfterPznArrival={true}
        />
        <LazyLoad offset={600}>
          <Breakpoint>
            {({ sm, md }) => (
              <HeroBanner
                qeId="reinforcementBanner"
                styles={styles}
                PrimaryContentComponent="div"
                primaryContentProps={{
                  className: clsx(styles.innerWrap, {
                    [styles.hasColorPicker]: hasColorPicker
                  }),
                  children: (
                    <Fragment>
                      {cardArtUrl && (
                        <Image
                          src={cardArtUrl}
                          alt={cardTitle}
                          className={styles.cardArt}
                        />
                      )}
                      {md && (
                        <ColorPicker
                          shortName={bannerData?.shortName}
                          parentType={parent.RIB_TABLET}
                        />
                      )}
                    </Fragment>
                  )
                }}
                SecondaryContentComponent="div"
                secondaryContentProps={{
                  className: styles.contentContainer,
                  children: (
                    <Fragment>
                      <Sanitizer
                        Component="h2"
                        className={styles.title}
                        safelySetInnerHTML={title}
                      />
                      <Typography Component="div" className={styles.subTitle}>
                        {dynAppStyling && learnMoreButton}
                        {subTitle}
                      </Typography>
                      {cardArtUrl && (
                        <div className={styles.cardArtMobileContainer}>
                          <Image
                            src={cardArtUrl}
                            alt={cardTitle}
                            className={styles.cardArt}
                          />
                        </div>
                      )}
                      {sm && (
                        <ColorPicker
                          shortName={bannerData?.shortName}
                          parentType={parent.RIB_MOBILE}
                        />
                      )}
                      <div className={styles.applyButtonWrapper}>
                        <ApplyAndAddEmpCard
                          styles={applyButtonStyles}
                          parent="_ReinforcementBanner"
                          linkType="reinforcement"
                          addAnEmployeeScrollDtm={reinforcementBanner}
                          hasUpgradeCta={hasUpgradeCta}
                        />
                      </div>
                      <div className={styles.tcLinksWrapper}>
                        <TcLinks {...tncProps} />
                      </div>
                    </Fragment>
                  )
                }}
              />
            )}
          </Breakpoint>
        </LazyLoad>
      </React.Fragment>
    );
  }
);

const mapStateToProps = (state, ownProps) => ({
  addAnEmployeeScrollDtm: getAddAnEmployeeDtmEvents(state),
  colorInfo: getSelectedColorInfo(ownProps.bannerData?.shortName)(state)
});

export default connect(mapStateToProps)(ReinforcementBanner);
